import { render, staticRenderFns } from "./OwnClassTeacherNewDialog.vue?vue&type=template&id=117ed794"
import script from "./OwnClassTeacherNewDialog.vue?vue&type=script&lang=js"
export * from "./OwnClassTeacherNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports